import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";

import useAppInsightsHandler from "hooks/useAppInsightsHandler.js";

import { deleteBaseline, getBaselines } from "api/baseline.js";

import { BaselineStrings, valueStrings } from "constants/constantStrings";
import { LOCAL_TIME_ZONE } from "constants/globalConstants";

import AddBaseLineModal from "components/AddBaseLineModal";
import AgTable from "components/AgTable";
import BadgeLabel from "components/BadgeLabel";
import DupontButton from "components/DupontButton";
import PageLoading from "components/PageLoading";

import Filter from "../../components/Filter";
import WindowWidth from "../../components/WindowWidth.jsx";

import BaselineDeleteModal from "./BaselineDeleteModal.jsx";
import getBaselineTableCols from "./BaselineTable.config.js";

const Baseline = props => {
  const [, width] = WindowWidth();
  const [baselines, setBaselines] = useState([]);
  const [baselineToDelete, setBaselineToDelete] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);
  const [filterValue, setFilterValue] = useState("");
  const [isDeleteBaselineModalOpen, setIsDeleteBaselineModalOpen] = useState(false);
  const [isBaselineFormOpen, setIsBaselineFormOpen] = useState(false);
  const [isviewOnly, setIsviewOnly] = useState(false);
  const [isClone, setIsClone] = useState(false);
  const [showTableFilterIcon, setShowTableFilterIcon] = useState(false);
  const [baselineBadgeCount, setBaselineBadgeCount] = useState();
  const { tagsAsObj } = useSelector(state => state.tags);
  const [tableColumns, setTableColumns] = useState([]);
  const [editBaselineId, setEditBaselineId] = useState();
  const [editBaselineType, setEditBaselineType] = useState();
  const [editBaselineName, setEditBaselineName] = useState();
  const [baselineTimezone, setBaselineTimezone] = useState(LOCAL_TIME_ZONE);
  const objAppInsights = useAppInsightsHandler();

  useEffect(() => {
    const columns = getBaselineTableCols(showTableFilterIcon);
    setTableColumns(columns);
  }, [showTableFilterIcon]);

  useEffect(() => {
    setBaselineBadgeCount(baselines?.length);
  }, [baselines]);

  useEffect(() => {
    const fetchBaselines = async () => {
      try {
        const response = await getBaselines();
        if (response && response.data && response.status >= 200 && response.status < 300) {
          const responseData = response.data;
          if (responseData && responseData.length > 0) {
            const baselineList = responseData;
            setBaselines(baselineList);
            setBaselineBadgeCount(baselineList?.length);
          }
        }
        setIsLoaded(true);
      } catch (err) {
        setIsLoaded(true);
      }
    };
    fetchBaselines();
  }, []);

  const onCellClicked = event => {
    objAppInsights.trackEvent("baselineRowClick");
    const { colId } = event.column;
    if (colId === "delete") {
      return;
    }
    setIsviewOnly(colId !== "clone");
    setIsClone(colId === "clone");
    const { Id, Name, Timezone, Type } = event.node.data;
    setBaselineTimezone(Timezone);
    setEditBaselineId(Id);
    setEditBaselineType(Type);
    setEditBaselineName(Name);
    setBaselineToDelete(Id);
    setIsBaselineFormOpen(true);
  };

  //need to verify functionality
  // const getBaselineValues = async () => {
  //   const dateString = selectedDate._d.toString().substring(4, 15);
  //   const dateTime = dateString + ' ' + newBaseline.Hour + ':' + newBaseline.Minute + ':' + newBaseline.Second;
  //   const baselineTimestamp = moment(dateTime, 'MMM DD YYYY hh:mm:ss', moment.defaultFormat).unix();

  //   if (newBaseline.TimeStamp !== baselineTimestamp || isTagsUpdated === true || isFetchReady) {
  //     try {
  //       const response = await getBaselinesFromTimestamp(baselineTimestamp, newBaseline.Timezone);
  //       if (response.status >= 200 && response.status < 300) {
  //         const Values = response.data;
  //         setNewBaseline({ ...newBaseline, Values: Values, Date: dateString, TimeStamp: baselineTimestamp });
  //         setValidateSuccessfull(true);
  //       }
  //     } catch (err) {}
  //   }
  // };

  // useEffect(() => {
  //   if (
  //     (newBaseline.RowClicked === 'false' && selectedDate && newBaseline.Hour && newBaseline.Minute && newBaseline.Second) ||
  //     isTagsUpdated === true
  //   ) {
  //     getBaselineValues();
  //   }
  // }, [isTagsUpdated]);

  const handleOpenBaselineForm = () => {
    setEditBaselineId(null);
    setEditBaselineType(null);
    setEditBaselineName(null);
    setBaselineTimezone(LOCAL_TIME_ZONE);
    setIsBaselineFormOpen(true);
    setIsviewOnly(false);
    setIsClone(false);
  };

  const handleDeleteBaseline = rowData => {
    objAppInsights.trackEvent("baselineDeleteClick");
    if (!isviewOnly) setBaselineToDelete(rowData.ID);
    setIsDeleteBaselineModalOpen(true);
  };

  const handleCloseDeleteBaselineModal = () => {
    setIsDeleteBaselineModalOpen(false);
    setBaselineToDelete("");
  };
  const submitDeleteBaseline = async () => {
    if (baselineToDelete) {
      const deleteBaselineID = async () => {
        const deleteObject = { BaselineID: baselineToDelete };
        try {
          const response = await deleteBaseline(deleteObject);
          if (response && response.Success === "Success") {
            const updatedBaselines = baselines.filter(baseline => baseline.ID !== baselineToDelete);
            setBaselines(updatedBaselines);
            setBaselineToDelete("");
            setIsDeleteBaselineModalOpen(false);
            setIsBaselineFormOpen(false);
          }
        } catch (err) {}
      };
      deleteBaselineID();
    }
  };

  const getFilteredBaselines = () => {
    // if (props.tier1) {
    //   return baselines.filter(baseline => baseline.Type !== "auto");
    // }
    return baselines;
  };

  const filteredBaselines = getFilteredBaselines();

  return (
    <div className={`app-wrapper`}>
      {!isLoaded && <PageLoading />}
      {isLoaded && props.tagsList.length > 0 && (
        <div>
          <div className="flex-between-center">
            <BadgeLabel badgeDescription={BaselineStrings.baseline} badgeText={baselineBadgeCount} />
            {(props.admin || props.tier1 || props.tier2) && (
              <div>
                <DupontButton onClick={handleOpenBaselineForm}>{BaselineStrings.addBaseLine.replace("[%]", valueStrings.add)}</DupontButton>
              </div>
            )}
          </div>
          <div className="flex-between-center">
            <div className="descriptionText ">{BaselineStrings.baselineMessage}</div>
            <div className="autoWidth">
              <Filter
                data={baselines}
                setFilterValue={setFilterValue}
                showfilter={false}
                setShowTableFilterIcon={setShowTableFilterIcon}
                showTableFilterIcon={showTableFilterIcon}
              />
            </div>
          </div>
          <AgTable
            rowData={filteredBaselines}
            onCellClicked={onCellClicked}
            quickFilterText={filterValue}
            columnDefs={tableColumns}
            context={{ handleDeleteBaseline, onCellClicked }}
            setBadgeCount={setBaselineBadgeCount}
          />
          <BaselineDeleteModal open={isDeleteBaselineModalOpen} handleClose={handleCloseDeleteBaselineModal} handleSubmit={submitDeleteBaseline} />
          {isBaselineFormOpen && (
            <AddBaseLineModal
              setIsBaselineFormOpen={setIsBaselineFormOpen}
              isviewOnly={isviewOnly}
              baselines={baselines}
              setBaselines={setBaselines}
              baselineTimezone={baselineTimezone}
              editBaselineId={editBaselineId}
              editBaselineType={editBaselineType}
              editBaselineName={editBaselineName}
              isClone={isClone}
            />
          )}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({ tags, user }) => ({
  tagsList: tags.tags,
  admin: user.isAdmin,
  tier1: user.isTier1,
  tier2: user.isTier2
});

export default connect(mapStateToProps)(Baseline);
